import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  resetMemory(request: Boundaries["resetMemory"]["request"]): void;
}

function useResetMemory(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isResetMemoryRequestPending),
    isRequestSuccess: useSelector(selector.isResetMemoryRequestSuccess),
    isRequestFailure: useSelector(selector.isResetMemoryRequestFailure),
    resetMemory: core.resetMemory,
  };
}

export { useResetMemory };
